module.exports = "<div class=\"this-object-on-other-websites\"><div class=\"segment-title\">Этот объект на других сайтах</div></div>"